import { Link, useParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { getTrailerQr, regenerateTrailerQr } from "../api/adminCheckouts";

export default function TrailerQr() {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const { data, isLoading, isError } = useQuery({
    queryKey: ["trailerQr", id],
    queryFn: () => getTrailerQr(id)
  });

  const regenerateMutation = useMutation({
    mutationFn: () => regenerateTrailerQr(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["trailerQr", id] });
      queryClient.invalidateQueries({ queryKey: ["trailers"] });
      toast.success("QR-token vernieuwd");
    },
    onError: (error) => toast.error(error.response?.data?.error || "QR-token vernieuwen mislukt")
  });

  if (isLoading) return <div className="loading-state">QR-code laden...</div>;

  if (isError || !data) {
    return (
      <section className="page">
        <div className="panel panel-pad">
          <h1 className="page-title">QR-code niet gevonden</h1>
          <Link className="button secondary" to="/trailers">Terug naar trailers</Link>
        </div>
      </section>
    );
  }

  const publicUrl = `${window.location.origin}${data.publicPath}`;
  const qrImage = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${encodeURIComponent(publicUrl)}`;

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">QR-code trailer</h1>
          <p className="page-subtitle">{data.trailer.name}</p>
        </div>
        <Link className="button secondary" to="/trailers">Terug</Link>
      </header>

      <div className="panel panel-pad qr-page">
        <div className="qr-card">
          <p className="sidebar-brand-title">DR-Renting</p>
          <h2 className="detail-title">{data.trailer.name}</h2>
          <img className="qr-image" src={qrImage} alt={`QR-code voor ${data.trailer.name}`} />
          <p className="row-meta">Scan voor trailer check-out</p>
        </div>

        <div className="detail-section">
          <h2 className="detail-title">Publieke checkout link</h2>
          <input className="input" readOnly value={publicUrl} />
          <div className="action-row" style={{ marginTop: 12 }}>
            <button
              className="button secondary"
              onClick={() => {
                navigator.clipboard?.writeText(publicUrl);
                toast.success("Link gekopieerd");
              }}
            >
              Copy link
            </button>
            <button className="button secondary" onClick={() => window.print()}>
              Print QR-code
            </button>
            <button
              className="button danger"
              disabled={regenerateMutation.isPending}
              onClick={() => {
                if (window.confirm("QR-token vernieuwen? Bestaande QR-stickers voor deze trailer werken daarna niet meer.")) {
                  regenerateMutation.mutate();
                }
              }}
            >
              QR-token vernieuwen
            </button>
          </div>
          <p className="page-subtitle" style={{ marginTop: 12 }}>
            Token: {data.qrToken}
          </p>
        </div>
      </div>
    </section>
  );
}
